
export default [
    {
        "id": 1,
        "url": "#",
        "latLng": [37.70, -122.41],
        "name": "Call with Jane",
        "date": "Tomorrow at 12:30 PM"
    },
    {
        "id": 2,
        "url": "#",
        "latLng": [37.59, -122.39],
        "name": "HackTM conference",
        "date": "In about 5 minutes"
    },
    {
        "id": 3,
        "url": "#",
        "latLng": [37.52, -122.29],
        "name": "Marketing event",
        "date": "Today at 1:00 PM"
    },
    {
        "id": 4,
        "url": "#",
        "latLng": [37.37, -122.12],
        "name": "Dinner with partners",
        "date": "In 2 hours"
    },
    {
        "id": 5,
        "url": "#",
        "latLng": [37.36, -121.94],
        "name": "Interview with Google",
        "date": "In two days at 15:00 PM"
    }
]